<div class="row" *ngIf="portalContent != '' && portalContent != null">
  <div class="contentbox mb-3">
    <div class="col col-12 portalcontent-container" [class.showmorecontent]="show" #portalcontentcontainer [style.height]="InnerHeight">
      <div [innerHTML]="portalContent | keepHtml" runScripts></div>
    </div>
    <a href="javascript:void(0)" (click)="showHideContent()" class="text-decoration-underline bold" *ngIf="showMoreButton && !showFullContentLink">{{ show ? 'Show less': 'Show more' }}</a>
  </div>
</div>
